class ConfirmOpen {
  constructor($root) {
    this.$root = $root;
  }

  confirm_open(object) {
    object.promise = new Promise((resolve, reject) => {
      object.resolve = resolve;
    });
    object.promise.then((value) => {
      if (value) {
        object.true();
      } else {
        object.false();
      }
      this.$root.confirm_data = false;
    });

    this.$root.confirm_data = object;
  }
}

export default ConfirmOpen;
